import { getCountries, getCountryCallingCode, isPossiblePhoneNumber, isValidPhoneNumber, } from "react-phone-number-input";
import { locales } from "./locales";
/**
 * This function returns an array composed by all country using getCountris function.
 * This is array is compose by OptionSelect objects.
 * The countries are translated using the currentLanguage provided.
 * @param currentLanguage
 * @returns
 */
export const phoneInputCountries = (currentLanguage) => getCountries().map((country) => ({
    label: `${locales[currentLanguage][country]} +${getCountryCallingCode(country)}`,
    value: country,
}));
/**
 * This function find the selected country in the array of countries.
 * @param {PhoneCountry} defaultCountry
 * @param currentLanguage
 * @returns
 */
export const getCountryAndPrefix = (defaultCountry, currentLanguage) => phoneInputCountries(currentLanguage).find((country) => country.value === defaultCountry);
export const translateSelectedValue = (selectedValue, currentLanguage) => ({
    label: `${locales[currentLanguage][selectedValue.value]} +${getCountryCallingCode(selectedValue.value)}`,
    value: selectedValue.value,
});
/**
 * This function validaded the phonenumber
 * @param selectedCountry
 * @param phoneNumber
 * @returns
 */
export const isValidNumber = (selectedCountry, phoneNumber) => isPossiblePhoneNumber(`+${getCountryCallingCode(selectedCountry) + phoneNumber}`) &&
    isValidPhoneNumber(`+${getCountryCallingCode(selectedCountry) + phoneNumber}`);
